import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

async function shortcutGuard(to: Route, from: Route, next: NavigationGuardNext) {
  // eslint-disable-next-line no-restricted-globals
  if (to.name !== 'admin:shortcuts') {
    store.commit('navigation/SET_SHOW_SHORTCUTS', false)
  }
  if (to.name === 'admin:shortcuts') {
    store.commit('navigation/SET_SHOW_SHORTCUTS', true)
  }
  return next()
}

export default shortcutGuard
